import * as React from 'react'

const SvgComponent = (props: any) => (
  <svg width={12} height={12} xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{'icons-download'}</title>
    <g fill="#4E516B" fillRule="nonzero">
      <path d="M6.438.75h-.875a.437.437 0 0 0-.438.438v2.187H2.937a.437.437 0 0 0-.328.725L5.67 7.6a.438.438 0 0 0 .658 0l3.063-3.5a.438.438 0 0 0-.33-.725H6.876V1.187A.437.437 0 0 0 6.437.75Z" />
      <path d="M9.5 9.5h-7V6.875H.75V9.5c0 .966.784 1.75 1.75 1.75h7a1.75 1.75 0 0 0 1.75-1.75V6.875H9.5V9.5Z" />
    </g>
  </svg>
)

export default SvgComponent
